<template lang="pug">
.container.grid-lg
  .card.mt-2
    .card-header
      .text-bold Filtrar
    .card-body
      form-filter(@submit="fetchReport")
  .full-height.loading.loading-lg(v-if="loading")
  div(v-else-if="report")
    div(v-if="report.length")
      .card.my-2.no-print
        .card-header
          .h5 Gráfico
        .card-body
          bar-chart(:data="chartData", :height="`${report.length * 50}px`")
      .card.my-2
        .card-header
          .h5 Tabela resumo
        .card-body
          table.table.table-striped.table-responsive
            thead
              tr
                th {{ "ordem_servico.assunto" | tModel }}
                th.text-right Quantidade
                th.text-right Média de dias
            tbody
              tr(v-for="item in report")
                td {{ item.descricao }}
                td.text-right {{ item.q }}
                td.text-right {{ Number(item.media_dias).toFixed(0) }}
    .card.mt-2(v-else)
      .card-body
        .empty
          .empty-icon
            i.fa.fa-search.fa-4x
          p.empty-title.h5 Nada encontrado
          p.empty-subtitle Não foram encontradas OS-m neste período
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import api from "@/api/indicadores/ordemServicos"
import FormFilter from "./components/Filter"

export default {
  data() {
    return {
      loading: false,
      report: null,
    }
  },
  components: { FormFilter },
  computed: {
    chartData() {
      return this.report.map((item) => [
        item.descricao,
        Number(item.media_dias).toFixed(0),
      ])
    },
  },
  methods: {
    async fetchReport(q = {}) {
      try {
        this.loading = true
        this.report = await api.tempoMedioPorAssuntos({ q })
      } catch (error) {
        toastErrors(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchReport()
  },
}
</script>
